/**
 * auth — the English half, typed against the German module, so a
 * missing or misspelled key is a type error in this file.
 */
import type { auth as de_auth } from '../de/auth';

export const auth: Record<keyof typeof de_auth, string> = {
  /* ---------------- auth ---------------- */
  'auth.signin': 'Sign in',
  'auth.register': 'Create account',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.password.hint': '(at least 10 characters)',
  'auth.name': 'Name (optional)',
  'auth.busy': 'one moment …',
  'auth.toRegister': 'New here? Create an account',
  'auth.toLogin': 'Already have an account? Sign in',

  /* the one place the product says what it is */
  'auth.tagline': 'VFR flight planning for Europe. Map, nav log, weather, terrain — and the German LBA form.',
};
